module.exports = __webpack_public_path__ + "img/c.bf46b35d.jpg";